import type { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg width={props.width || '1em'} height={props.height || '1em'} fill="none" {...props} viewBox="0 0 14 14">
		<path
			stroke={props.color || 'var(--icon)'}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M7 1.313c-2.174 0-3.938 1.678-3.938 3.746 0 2.378 2.626 6.148 3.59 7.45a.43.43 0 0 0 .697 0c.963-1.301 3.588-5.07 3.588-7.45 0-2.068-1.763-3.747-3.937-3.747Z"
		/>
		<path
			stroke={props.color || 'var(--icon)'}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M7 6.563a1.313 1.313 0 1 0 0-2.626 1.313 1.313 0 0 0 0 2.626Z"
		/>
	</svg>
);
export default SvgComponent;
